export enum MUTATION_KEYS {
  CREATE_DOCUMENT_VERSION = 'CREATE_DOCUMENT_VERSION',
}

export default MUTATION_KEYS
